<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	// Group control components
	import ControlGroupOnOff from 'src/components/Controls/Group/ControlGroupOnOff.svelte';
	import ControlGroupWhiteChannel from 'src/components/Controls/Group/ControlGroupWhiteChannel.svelte';
	import ControlGroupGainBrightness from 'src/components/Controls/Group/ControlGroupGainBrightness.svelte';
	import ControlGroupDirection from 'src/components/Controls/Group/ControlGroupDirection.svelte';
	import ControlGroupPosition from 'src/components/Controls/Group/ControlGroupPosition.svelte';
	import ControlGroupThermostat from 'src/components/Controls/Group/ControlGroupThermostat.svelte';
	import GroupDevicesListScrollable from 'src/components/Groups/GroupDevicesListScrollable.svelte';

	export let group;
	export let type;
	export let list = [];
	export let lights_category_devices = [];
	export let white_channel_support_lights = [];
</script>

<SidepanelContent>
	<div class="flex-full-height" slot="default">
		{#if type === 'roller'}
			<ControlGroupPosition {group} />
		{:else if type === 'thermostat'}
			<GroupDevicesListScrollable {list} />
		{:else}
			{#if white_channel_support_lights.length > 0}
				<div class="flex-full-height justify-content-end">
					<ControlGroupWhiteChannel {white_channel_support_lights} type={'horizontal'} />
				</div>
			{/if}

			{#if lights_category_devices.filter((d) => d.slider !== undefined).length > 0 && white_channel_support_lights.length < 1}
				<ControlGroupGainBrightness
					{lights_category_devices}
					type={'vertical'}
					groupId={group.id}
				/>
			{:else if lights_category_devices.filter((d) => d.slider !== undefined).length > 0}
				<ControlGroupGainBrightness
					{lights_category_devices}
					type={'horizontal'}
					groupId={group.id}
				/>
			{:else if type !== 'light'}
				<GroupDevicesListScrollable {list} />
			{:else}
				<!-- if there is no any data from devices and we have only on/off buttons use default full-height div-->
				<div class="flex-full-height" />
			{/if}
		{/if}
	</div>

	<div slot="staticBottom">
		{#if type === 'roller'}
			<ControlGroupDirection {group} variant="drawer" />
		{:else if type === 'thermostat'}
			<ControlGroupThermostat {group} variant="drawer" />
		{:else}
			<ControlGroupOnOff {group} variant="drawer" />
		{/if}
	</div>
</SidepanelContent>
